/* ---------------------------------------------------------------------------
 * MD Fashionwear — "Find my size" (owner 2026-11-03)
 *
 * A card under "Add to Wishlist" on product pages that have THEIR OWN size chart (the custom.custom_size_chart
 * metafield, shown in the size-guide drawer). Products on the general guide get nothing. The shopper enters her
 * bust, waist and hips, picks how she likes it to fit, and gets one size, with the reason.
 *
 * The maths: the chart lists GARMENT measurements, and a stretchy bodycon dress lists a smaller bust than a body.
 * So each column is first compared with MD's general body guide (bust/waist/hips per size) to learn how this
 * piece is cut: its "ease" (Thea S bust 77 vs body 87 = -10, stretch; a knit set S bust 112 = +25, oversized).
 * Her measurement plus that ease is placed between the chart's sizes; how she likes the fit decides when to
 * round up. A range ("66-71") counts by its middle and goes through the same check: supplier ranges are
 * often stretch-fabric sizes, not bodies.
 *
 * Loaded from snippets/js-variables.liquid with assets/md-size-finder.css.
 * LIVE = false keeps it hidden; add ?fit=preview to a product URL to see it (remembered on that browser).
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';
  var LIVE = true;
  if (window.__mdSizeFinder) return;
  window.__mdSizeFinder = true;
  var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  if (!handle) return;
  var preview = /[?&]fit=preview\b/.test(location.search);
  try { if (preview) localStorage.setItem('md_fit_preview', '1'); } catch (e) {}
  var allowed = LIVE || preview || (function () { try { return localStorage.getItem('md_fit_preview') === '1'; } catch (e) { return false; } })();
  if (!allowed) return;

  // MD's general size guide (/pages/all-size-guides), middle of each body range in cm.
  var BODY = {
    XS: { bust: 82, waist: 63, hips: 90 }, S: { bust: 87, waist: 68, hips: 95 }, M: { bust: 92, waist: 73, hips: 100 },
    L: { bust: 97, waist: 78, hips: 105 }, XL: { bust: 102, waist: 83, hips: 110 }, XXL: { bust: 107, waist: 88, hips: 115 }
  };
  BODY['2XL'] = BODY.XXL;
  var LABEL = { bust: 'Bust', waist: 'Waist', hips: 'Hips' };
  // Round up once she is this far past a size: close fit holds on, relaxed moves up early.
  var ROUND = { close: 0.65, cut: 0.4, relaxed: 0.15 };

  /* ------------------------------------------------------------ the chart */
  function num(s) {
    var m = String(s).replace(',', '.').match(/(\d+(?:\.\d+)?)(?:\s*[-–~]\s*(\d+(?:\.\d+)?))?/);
    if (!m) return null;
    var a = parseFloat(m[1]), b = m[2] ? parseFloat(m[2]) : null;
    return b ? { mid: (a + b) / 2, lo: a, hi: b, range: true } : { mid: a, range: false };
  }
  function which(h) {
    h = h.toLowerCase();
    if (/length|sleeve|cuff|stretch|rise|inseam|hem|shoulder/.test(h)) return null;
    if (/bust|chest/.test(h)) return 'bust';
    if (/hip/.test(h)) return 'hips';
    if (/waist/.test(h)) return 'waist';
    return null;
  }
  // The piece's own chart from the size-guide drawer, or null (general guide, no chart, or nothing usable).
  function readChart() {
    var tables = document.querySelectorAll('.size-guide-drawer table, table.size-chart');
    for (var i = 0; i < tables.length; i++) {
      var t = tables[i], rows = [].slice.call(t.rows);
      if (!rows.length || !/^\s*size\s*$/i.test(rows[0].cells[0] && rows[0].cells[0].textContent || '')) continue;
      var heads = [].slice.call(rows[0].cells).map(function (c) { return c.textContent.trim(); });
      var cols = {};
      heads.forEach(function (h, j) { var k = which(h); if (j && k && cols[k] == null) cols[k] = j; });
      var sizes = rows.slice(1).map(function (r) {
        var o = { size: (r.cells[0] && r.cells[0].textContent || '').trim().toUpperCase(), v: {} };
        Object.keys(cols).forEach(function (k) { var n = num(r.cells[cols[k]] && r.cells[cols[k]].textContent || ''); if (n) o.v[k] = n; });
        return o;
      }).filter(function (o) { return o.size; });
      // A column that does not grow from size to size is a typo in the supplier chart: leave it out.
      Object.keys(cols).forEach(function (k) {
        var vals = sizes.map(function (o) { return o.v[k] && o.v[k].mid; });
        var ok = vals.every(function (x) { return x != null; }) && vals.every(function (x, j) { return !j || x > vals[j - 1]; });
        if (!ok) { delete cols[k]; sizes.forEach(function (o) { delete o.v[k]; }); }
      });
      if (sizes.length >= 2 && Object.keys(cols).length) return { sizes: sizes, keys: Object.keys(cols) };
    }
    return null;
  }

  /* ------------------------------------------------------------ the maths */
  function ease(chart, k) {
    var d = chart.sizes.filter(function (o) { return BODY[o.size]; }).map(function (o) { return o.v[k].mid - BODY[o.size][k]; });
    if (!d.length) return k === 'waist' ? 2 : 4;
    d.sort(function (a, b) { return a - b; });
    var e = d[Math.floor(d.length / 2)];
    return e > 0 && e < 2 ? 2 : e;   // a woven piece always needs a little room
  }
  // Where her measurement sits between the sizes: 0 = first size, 1.5 = halfway between the 2nd and 3rd.
  function position(chart, k, body) {
    var e = ease(chart, k);
    var xs = chart.sizes.map(function (o) { return o.v[k].mid - e; });
    var n = xs.length;
    if (body <= xs[0]) return (body - xs[0]) / Math.max(1, xs[1] - xs[0]);
    for (var i = 1; i < n; i++) if (body <= xs[i]) return i - 1 + (body - xs[i - 1]) / (xs[i] - xs[i - 1]);
    return n - 1 + (body - xs[n - 1]) / Math.max(1, xs[n - 1] - xs[n - 2]);
  }
  function recommend(chart, me, fit) {
    var used = chart.keys.filter(function (k) { return me[k] > 0; });
    if (!used.length) return null;
    var pos = {}, need = -Infinity, by = null;
    used.forEach(function (k) { pos[k] = position(chart, k, me[k]); if (pos[k] > need) { need = pos[k]; by = k; } });
    var n = chart.sizes.length, base = Math.floor(need), frac = need - base;
    var idx = Math.max(0, Math.min(n - 1, frac > ROUND[fit] ? base + 1 : base));
    var lo = Math.max(0, Math.min(n - 1, base)), hi = Math.max(0, Math.min(n - 1, base + 1));
    var notes = used.map(function (k) {
      var d = pos[k] - idx;
      return { k: k, word: d > 0.25 ? 'snug' : d < -0.75 ? 'roomy' : 'good' };
    });
    return {
      size: chart.sizes[idx].size, by: by, notes: notes,
      between: need >= 0 && need <= n - 1 && frac > 0.3 && frac < 0.7 && lo !== hi ? [chart.sizes[lo].size, chart.sizes[hi].size] : null,
      over: need > n - 1 + 0.8, under: need < -1.3
    };
  }

  /* ------------------------------------------------------------ the page */
  var P = null, CHART = null;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sizeIndex() { return (P.options || []).findIndex(function (o) { return /^size$/i.test(o.name || o); }); }
  function soldOut(size) {
    var i = sizeIndex();
    var vs = (P.variants || []).filter(function (v) { return String(v.options[i]).toUpperCase() === size; });
    return vs.length && vs.every(function (v) { return !v.available; });
  }
  // The theme's size radios carry option ids, not names: find the button by its label (S, M, L…).
  function pickOnPage(size) {
    var trig = document.querySelector('.size-guide-trigger'), box = trig && trig.closest('fieldset');
    var inputs = (box || document).querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var lab = inputs[i].id && document.querySelector('label[for="' + inputs[i].id + '"]');
      var name = (lab ? lab.textContent : inputs[i].value).trim().toUpperCase();
      if (name === size) { (lab || inputs[i]).click(); return true; }
    }
    return false;
  }
  // A full-width card with the other ones: under "Add to Wishlist", above "Try it on" (owner 2026-11-03).
  function place() {
    if (document.querySelector('.md-fit-link')) return true;
    var hearts = document.querySelectorAll('[data-wishlist-toggle]'), anchor = null;
    for (var i = 0; i < hearts.length; i++) if (!hearts[i].closest('product-card, .product-card, .product-item')) { anchor = hearts[i]; break; }
    if (!anchor) { var trig = document.querySelector('.size-guide-trigger'); anchor = trig && trig.closest('fieldset'); }
    if (!anchor) return false;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'md-fit-link';
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="1.5" y="8" width="21" height="8" rx="1.5"/><path d="M6 8v3M10 8v4M14 8v3M18 8v4"/></svg><span>Not sure of your size? <b>Find my size</b></span>';
    b.addEventListener('click', open);
    anchor.parentNode.insertBefore(b, anchor.nextSibling);
    // Try it on may load later and land between: keep Find my size first.
    setTimeout(function () { var t = document.querySelector('.md-tryon-btn'); if (t && t.nextElementSibling === b) t.parentNode.insertBefore(b, t); }, 3000);
    return true;
  }

  /* ------------------------------------------------------------ the pop-up */
  var M, S = { unit: 'cm', fit: 'cut', me: {} };
  try { var saved = JSON.parse(localStorage.getItem('md_fit_me') || 'null'); if (saved) { S.me = saved.me || {}; S.fit = saved.fit || 'cut'; } } catch (e) {}

  function open() {
    if (!M) {
      M = document.createElement('div');
      M.className = 'md-fit';
      M.innerHTML = '<div class="md-fit__scrim" data-close></div><div class="md-fit__box" role="dialog" aria-modal="true" aria-label="Find my size">' +
        '<button class="md-fit__x" type="button" data-close aria-label="Close">&times;</button><div class="md-fit__body"></div></div>';
      document.body.appendChild(M);
      M.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && M.classList.contains('is-open')) close(); });
    }
    CHART = CHART || readChart();
    M.classList.add('is-open');
    document.documentElement.classList.add('md-fit-lock');
    step1();
  }
  function close() { M.classList.remove('is-open'); document.documentElement.classList.remove('md-fit-lock'); }
  function body(html) { M.querySelector('.md-fit__body').innerHTML = html; }
  function head(n, title, sub) {
    return '<p class="md-fit__eyebrow">Find my size · Step ' + n + ' of 2</p><div class="md-fit__bar"><i style="width:' + (n * 50) + '%"></i></div>' +
      '<h2 class="md-fit__title">' + title + '</h2>' + (sub ? '<p class="md-fit__sub">' + sub + '</p>' : '');
  }
  function shown(k) { var v = S.me[k]; return v ? (S.unit === 'in' ? Math.round(v / 2.54 * 10) / 10 : Math.round(v)) : ''; }

  // 1. Her measurements (only the ones this chart can use).
  function step1() {
    var tips = { bust: 'Around the fullest part of your bust', waist: 'Around the narrowest part of your waist', hips: 'Around the fullest part of your hips' };
    body(head(1, 'Your measurements', 'Measure your body, not your clothes, with a soft tape.') +
      '<div class="md-fit__units"><button type="button" data-unit="cm"' + (S.unit === 'cm' ? ' class="is-on"' : '') + '>cm</button><button type="button" data-unit="in"' + (S.unit === 'in' ? ' class="is-on"' : '') + '>inches</button></div>' +
      CHART.keys.map(function (k) {
        return '<label class="md-fit__field"><span><b>' + LABEL[k] + '</b><small>' + tips[k] + '</small></span>' +
          '<span class="md-fit__input"><input type="number" inputmode="decimal" step="0.5" min="0" data-k="' + k + '" value="' + shown(k) + '" placeholder="e.g. ' + (S.unit === 'cm' ? ({ bust: 88, waist: 70, hips: 96 })[k] : ({ bust: 34.5, waist: 27.5, hips: 38 })[k]) + '"><em>' + S.unit + '</em></span></label>';
      }).join('') +
      '<p class="md-fit__err" hidden data-err>Please fill in at least one measurement.</p>' +
      '<button type="button" class="md-fit__cta" data-next>Next</button>');
    M.querySelectorAll('[data-unit]').forEach(function (b) {
      b.addEventListener('click', function () { read(); S.unit = b.getAttribute('data-unit'); step1(); });
    });
    M.querySelector('[data-next]').addEventListener('click', function () {
      read();
      var any = CHART.keys.some(function (k) { return S.me[k] > 0; });
      if (!any) { M.querySelector('[data-err]').hidden = false; return; }
      step2();
    });
  }
  function read() {
    M.querySelectorAll('[data-k]').forEach(function (inp) {
      var v = parseFloat(String(inp.value).replace(',', '.'));
      S.me[inp.getAttribute('data-k')] = v > 0 ? (S.unit === 'in' ? v * 2.54 : v) : 0;
    });
  }

  // 2. How she likes it to fit.
  function step2() {
    var opts = [['close', 'Close', 'Fitted to the body'], ['cut', 'As designed', 'The way it is made to fit'], ['relaxed', 'Relaxed', 'A little more room']];
    body(head(2, 'How do you like it to fit?', '') +
      '<div class="md-fit__opts">' + opts.map(function (o) {
        return '<button type="button" class="md-fit__opt' + (S.fit === o[0] ? ' is-on' : '') + '" data-fit="' + o[0] + '"><b>' + o[1] + '</b><small>' + o[2] + '</small></button>';
      }).join('') + '</div>' +
      '<button type="button" class="md-fit__cta" data-show>Show my size</button>' +
      '<button type="button" class="md-fit__link" data-back>Back</button>');
    M.querySelectorAll('[data-fit]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.fit = b.getAttribute('data-fit');
        M.querySelectorAll('[data-fit]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      });
    });
    M.querySelector('[data-back]').addEventListener('click', step1);
    M.querySelector('[data-show]').addEventListener('click', result);
  }

  // 3. The size.
  function result() {
    try { localStorage.setItem('md_fit_me', JSON.stringify({ me: S.me, fit: S.fit })); } catch (e) {}
    var r = recommend(CHART, S.me, S.fit);
    if (!r) return step1();
    var gone = soldOut(r.size);
    var lines = r.notes.map(function (n) {
      return '<li><span>' + LABEL[n.k] + '</span><b class="is-' + n.word + '">' + ({ good: 'Good fit', snug: 'A little snug', roomy: 'A little roomy' })[n.word] + '</b></li>';
    }).join('');
    var extra = r.over ? 'Your measurements are above this chart, so even ' + esc(r.size) + ' may feel tight. Message us and we will help you choose.'
      : r.under ? 'Your measurements are below this chart, so ' + esc(r.size) + ' may feel loose.'
      : r.between ? 'You are between ' + esc(r.between[0]) + ' and ' + esc(r.between[1]) + ': ' + esc(r.between[0]) + ' fits closer, ' + esc(r.between[1]) + ' gives more room.' : '';
    body('<p class="md-fit__eyebrow">Find my size</p>' +
      '<div class="md-fit__result"><small>Your size in this piece</small><strong>' + esc(r.size) + '</strong>' +
      '<span>Based on this piece\'s own size chart' + (r.by ? ' and your ' + LABEL[r.by].toLowerCase() : '') + '.</span></div>' +
      '<ul class="md-fit__notes">' + lines + '</ul>' +
      (extra ? '<p class="md-fit__tip">' + extra + '</p>' : '') +
      (gone ? '<p class="md-fit__err">' + esc(r.size) + ' is sold out in this colour right now.</p>' : '') +
      (gone ? '' : '<button type="button" class="md-fit__cta" data-pick="' + esc(r.size) + '">Select size ' + esc(r.size) + '</button>') +
      '<button type="button" class="md-fit__link" data-redo>Change my measurements</button>' +
      '<p class="md-fit__fine">Fabric and stretch vary from piece to piece; measurements can differ by 1–3 cm.</p>');
    var pick = M.querySelector('[data-pick]');
    if (pick) pick.addEventListener('click', function () { pickOnPage(r.size); close(); });
    M.querySelector('[data-redo]').addEventListener('click', step1);
  }

  function boot() {
    if (!readChart()) return;   // general guide or no chart: no size finder
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      P = p;
      if (!p || !p.id || sizeIndex() < 0) return;
      CHART = readChart();
      // Only the sizes this piece is sold in.
      var sold = {}, i = sizeIndex();
      (p.variants || []).forEach(function (v) { sold[String(v.options[i]).toUpperCase()] = 1; });
      var kept = CHART.sizes.filter(function (o) { return sold[o.size]; });
      if (kept.length >= 2) CHART.sizes = kept;
      if (place()) return;
      var n = 0, t = setInterval(function () { if (place() || ++n > 20) clearInterval(t); }, 500);
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();